import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface EmptyQuestionsBlockProps {
  onClick: () => void;
}

export const EmptyQuestionsBlock = ({ onClick }: EmptyQuestionsBlockProps) => (
  <div className="bg-secondary flex items-center rounded-lg py-16">
    <div className="mx-auto text-center">
      <Typography.TitleMd>
        {t("courses.edit.lesson.add_question")}
      </Typography.TitleMd>
      <Typography.BodyXs>
        {t("courses.edit.lesson.start_by_adding_questions")}
      </Typography.BodyXs>
      <Button
        type="button"
        large
        variant="secondary"
        className="mx-auto mt-6 flex"
        onClick={onClick}
      >
        <Icon type="plus" useWithFillCurrentColor className="mr-2" />
        {t("courses.edit.lesson.add_question")}
      </Button>
    </div>
  </div>
);
